import { useQuery } from '@tanstack/react-query'
import { useState } from 'react'
import { ApiError } from '../../api/client'
import { adamCronShellQuery, rebuildAdamStuckCron } from '../../api/settingsEaseedeskAdamIntop'
import { toast } from '../../ui/notify'
import { LoadFailed } from '../../ui/LoadFailed'
import { Spinner } from '../../ui/Spinner'

/**
 * Settings -> Easeedesk -> Adam Intop -> Adam Cron Settings, element cu
 * element fata de `easeedesk_settings/adam_intop/cron_stucked_tickets.php`:
 * titlul cu numele furnizorului si butonul "Refresh cron", care cere
 * serverului de cronuri `adam_intop/check_stuck_commands_cron/{sp}/create/15`
 * (`cron_stucked_tickets-1.js`: "Configuration build successfully.").
 */
export function AdamIntopCronPage() {
  const shell = useQuery(adamCronShellQuery())
  const [busy, setBusy] = useState(false)

  if (shell.error instanceof ApiError && shell.error.status === 403) {
    return (
      <div className="alert alert-danger">
        <i className="fas fa-exclamation-circle" aria-hidden="true"></i> You do not have access to this action.
      </div>
    )
  }
  if (shell.error) {
    return <LoadFailed error={shell.error} onRetry={() => void shell.refetch()} what="the Adam cron screen" />
  }
  if (!shell.data) return <Spinner />

  const rebuild = () => {
    setBusy(true)
    void rebuildAdamStuckCron()
      .then((answer) => {
        setBusy(false)
        if (answer.result === 'done') toast('Configuration build successfully.', 'Success')
        else toast(answer.message || 'Something went wrong.', 'Error', 'error')
      })
      .catch(() => {
        setBusy(false)
        toast('Something went wrong.', 'Error', 'error')
      })
  }

  return (
    <div>
      <h4>
        <strong>Cron</strong> Settings for <strong> {shell.data.providerName}</strong> SP{' '}
      </h4>
      <label className="color" style={{ marginBottom: 0 }}>
        Manage <strong>Cron settings</strong> for Adam Intop{' '}
      </label>

      <button type="button" className="btn btn-primary pull-right me-2 check-stucked-tickets" disabled={busy} onClick={rebuild}>
        <i className="fas fa-sync-alt" aria-hidden="true"></i> Refresh cron
      </button>

      <hr />
    </div>
  )
}
